import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useStorage } from "@vueuse/core";

export const useCartStore = defineStore("CartStore", () => {
  // State
  const showingCart = ref(false);
  const tracks = useStorage("cart", []);

  // Getters
  const count = computed(() => tracks.value.length);
  const isEmpty = computed(() => count.value === 0);
  const trackIds = computed(() => tracks.value.map((track) => track.id));

  // Actions
  const add = function add(track) {
    if (!trackIds.value.includes(track.id)) {
      tracks.value.push(track);
    }
    showingCart.value = true;
  };

  const remove = function remove(track) {
    tracks.value = tracks.value.filter((t) => t.id !== track.id);
  };

  const showCart = function showCart() {
    showingCart.value = true;
  };

  const hideCart = function hideCart() {
    showingCart.value = false;
  };

  return {
    showingCart,
    tracks,
    count,
    isEmpty,
    add,
    remove,
    showCart,
    hideCart,
  };
});
